import React from 'react';
import Slider from 'react-slick';
import { TYPE } from '../../constant';
import { useUserInfo } from '../../hooks';
import { BackButtons, MenuButton } from '../navigate';

const settings = {
  dots: true,
  arrows: false
};

const slideImg = {
  mathpid: [
    {
      pc: "./static/images/common/img_lc_01_00_mathpid_01@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_mathpid_01@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_mathpid_02@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_mathpid_02@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_mathpid_03@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_mathpid_03@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_mathpid_04@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_mathpid_04@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_mathpid_05@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_mathpid_05@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_mathpid_06@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_mathpid_06@2x.png",
    },
  ],
  barosem: [
    {
      pc: "./static/images/common/img_lc_01_00_barosem_01@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_barosem_01@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_barosem_02@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_barosem_02@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_barosem_03@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_barosem_03@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_barosem_04@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_barosem_04@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_barosem_05@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_barosem_05@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_barosem_06@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_barosem_06@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_barosem_07@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_barosem_07@2x.png",
    },
    {
      pc: "./static/images/common/img_lc_01_00_barosem_08@2x.png",
      m: "./static/images/common/img_mo_lc_01_00_barosem_08@2x.png",
    }
  ]
};

function IntroductionV2(props) {
  const { info } = useUserInfo();
  return (
    <React.Fragment>
      <div className="header_top gm l_gray">
        <div className="inner">
          <div className="btns_wrap header-trans cls">
            <div className="app_btn">
              <BackButtons />
            </div>
            <div className="right_area">
              <div className="menu_btn">
                <MenuButton
                  iconPath="/static/images/icon/ic_mn_w@2x.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="layout-def tutorial_slide bg_gray type2 gm">
        <div className="container">
          <div className="inner">
            <div className="slide_wrap">
              <div className="slide_cont">
                <Slider className="slick_slider js_slick slick-dotted" {...settings}>
                  {
                    info.channelCode === TYPE.CHANNEL.WJTB
                      ? (
                        slideImg.mathpid.map((item, index) => (
                          <div className="img_cont" key={index}>
                            <img className="for_pc_t" src={item.pc} alt="" />
                            <img className="for_m" src={item.m} alt="" />
                          </div>
                        ))
                      )
                      : (
                        slideImg.barosem.map((item, index) => (
                          <div className="img_cont" key={index}>
                            <img className="for_pc_t" src={item.pc} alt="" />
                            <img className="for_m" src={item.m} alt="" />
                          </div>
                        ))
                      )
                  }
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default IntroductionV2;